import React from 'react';
import classNames from 'classnames';
import { translate } from 'components/Translation';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import Donations from './subcomponents/Donations';
import styles from 'assets/jss/material-dashboard-pro-react/views/topUpAddOns/donationTabStyle';
import { makeStyles } from '@material-ui/core';
import { HeadingSBold } from 'components/Typography/Typography';
import Donate from './subcomponents/Donate';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IDonationTabProps {
	showDonations: boolean;
	onChangeShowDonations: () => void;
	selectedDonation?: types.payment.IDonation;
	setSelectedDonation: React.Dispatch<React.SetStateAction<types.payment.IDonation | undefined>>;
	onBack?: () => void;
	onNext?: () => void;
}

const DonationTab = (props: IDonationTabProps) => {
	const { showDonations, onChangeShowDonations, selectedDonation, setSelectedDonation } = props;
	const classes = useStyles();
	return (
		<div className={classNames(classes.wrapper, classes.donationTabWrapper)}>
			<HeadingSBold disableMargin>{translate('topup.donate.header')}</HeadingSBold>

			<Donate showDonations={showDonations} onChangeShowDonations={onChangeShowDonations} />

			<ConditionalRender
				show={showDonations}
				onTrue={() => (
					<Donations selectedDonation={selectedDonation} setSelectedDonation={setSelectedDonation} />
				)}
				onFalse={() => <div className={classes.emptyDonations} />}
			/>
		</div>
	);
};

export default DonationTab;
